import React from 'react'
import { withIcon } from '../../withIcon'

function BellSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M13.4932 18.0146C13.4931 18.8356 12.8248 19.4998 12 19.5C11.1752 19.4998 10.5079 18.8356 10.5078 18.0146H13.4932ZM12 4.5C12.3973 4.5002 12.7197 4.82235 12.7197 5.21973V6.33203C14.853 6.65893 16.5328 8.41712 16.8154 10.6299H16.8584V15.5771L18 16.6367V17.3438H6V16.6367L7.1416 15.5771V10.6299H7.18457C7.46723 8.41712 9.14701 6.65893 11.2803 6.33203V5.21973C11.2803 4.82235 11.6027 4.5002 12 4.5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(BellSolidIcon)
